import angular from 'angular';
import ComponentsModule from '../../../components-module';
import template from './code-aside.html';

const COMPONENT_NAME = 'codeAside';

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,
    transclude: true,

    bindings: {
      isUnfolded: '<?',
      showToggle: '<?'
    },

    controller: ($scope, $element) => {
      let ctrl = $scope.$ctrl;

      ctrl.toggle = () => {
        let toggleEvent = new CustomEvent ('toggle');
        $element[0].dispatchEvent (toggleEvent);
      };

      ctrl.$onInit = () => {
        if (ctrl.showToggle === undefined) {
          ctrl.showToggle = true;
        }

        ctrl.unfoldLeft = $element[0].classList && $element[0].classList.contains ('unfold-left') ? true : false;
      };
    }
  });

export default COMPONENT_NAME;
